window.Pagination = function(
  $container, // Parent container to pagination element
  pages, // Total amount of pages
  initialPage // [optional] current active page number - defaults to 1 if not present
) {
  initialPage = initialPage || 1;

  let $pagination = $container.children('.pagination-container');
  let $prevButton = $pagination.children('.prev-button');
  let $nextButton = $pagination.children('.next-button');
  let $lowerPageDots = $pagination.children('.lower-page-dots');
  let $higherPageDots = $pagination.children('.higher-page-dots');
  let $currentPage = $pagination.children('.current-page-button');
  let $firstPage = $pagination.children('.first-page-button');
  let $lastPage = $pagination.children('.last-page-button');
  let $prevPageTwoBack = $pagination.children('.active-minus-two');
  let $prevPage = $pagination.children('.active-minus-one');
  let $nextPage = $pagination.children('.active-plus-one');
  let $nextPageTwoForward = $pagination.children('.active-plus-two');

  // If custom handling, provide this function with the new page whenever a page changes;
  // otherwise, with an AG Grid implementation, the new page can be pulled from arguments provided by the library
  function pageChanged(currentPage) {
    $prevButton.removeAttr('disabled');
    $nextButton.removeAttr('disabled');

    $lowerPageDots.show();
    $higherPageDots.show();
    $firstPage.show();
    $lastPage.show();

    $prevPageTwoBack.hide();
    $prevPage.show().text(currentPage - 1);
    $currentPage.show().text(currentPage);
    $nextPage.show().text(currentPage + 1);
    $nextPageTwoForward.hide();

    if (currentPage < 4) {
      if (currentPage < 3) {
        $firstPage.hide();
      }
      $lowerPageDots.hide();
      $higherPageDots.show();
    } else if (currentPage > pages - 3) {
      if (currentPage > pages - 2) {
        $lastPage.hide();
      }
      $lowerPageDots.show();
      $higherPageDots.hide();
    }

    if (currentPage === 1) {
      $prevButton.attr('disabled', 'disabled');
      $prevPageTwoBack.hide();
      $prevPage.hide();
      $nextPage.show().text(currentPage + 1);
      $nextPageTwoForward.show().text(currentPage + 2);
    } else if (currentPage === pages) {
      $nextButton.attr('disabled', 'disabled');
      $prevPageTwoBack.show().text(currentPage - 2);
      $prevPage.show().text(currentPage - 1);
      $nextPage.hide();
      $nextPageTwoForward.hide();
    }
  }

  pageChanged(initialPage);

  $lastPage.text(pages);

  return {
    pageChanged: pageChanged,
    prevPage: $prevPage,
    prevButton: $prevButton,
    nextPage: $nextPage,
    nextButton: $nextButton,
    firstPage: $firstPage,
    lastPage: $lastPage,
    twoBack: $prevPageTwoBack,
    twoForward: $nextPageTwoForward
  };
};

window.addEventListener('load', function() {});
